import { useState } from "react";
import { Newsletter } from "../components";
import { GUIDES, GUIDE_CATEGORIES } from "../data/content";

export default function Guides() {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? GUIDES : GUIDES.filter(g => g.category === active);

  return (
    <div className="page">
      <div className="page-hero">
        <div className="page-eyebrow">Free Resources</div>
        <h1 className="page-title">Guides &<br />Downloads</h1>
        <p className="page-subtitle">
          Checklists, budget templates, spreadsheets and itineraries - everything I wish I'd had when I first arrived.
          All free, always.
        </p>
      </div>

      {/* Stats bar */}
      <div style={{ display: "flex", gap: "0", background: "var(--border)" }}>
        {[
          { num: `${GUIDES.length}`, label: "Free resources" },
          { num: "100%", label: "Always free" },
          { num: "PDF + XLS", label: "Formats" },
          { num: "Updated", label: "Regularly" },
        ].map(({ num, label }) => (
          <div key={label} style={{
            flex: 1, padding: "1.5rem 2rem", background: "var(--bg-alt)",
            borderRight: "1px solid var(--border)", textAlign: "center"
          }}>
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.5rem", fontWeight: 900, color: "var(--text)" }}>{num}</div>
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: "0.62rem", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--text-mute)", marginTop: "0.25rem" }}>{label}</div>
          </div>
        ))}
      </div>

      <div className="filter-bar">
        {GUIDE_CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`filter-btn${active === cat ? " active" : ""}`}
            onClick={() => setActive(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div style={{ padding: "1.5px", background: "var(--bg)" }}>
        <div className="guides-grid">
          {filtered.map(guide => (
            <div className="guide-card" key={guide.id}>
              <span className="guide-icon">{guide.icon}</span>
              <div className="guide-category">{guide.category}</div>
              <h3 className="guide-title">{guide.title}</h3>
              <p className="guide-description">{guide.description}</p>
              <div className="guide-footer">
                <span className="guide-type">{guide.type}</span>
                <a href={guide.file} download className="guide-download-btn">
                  Download ↓
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Strip */}
      <div style={{
        background: "var(--bg-dark)", padding: "4rem 5rem",
        display: "flex", alignItems: "center", justifyContent: "space-between", gap: "2rem"
      }}>
        <div>
          <div style={{ fontFamily: "'DM Mono',monospace", fontSize: "0.68rem", letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.4)", marginBottom: "0.75rem" }}>
            Want more?
          </div>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "2rem", fontWeight: 900, color: "white", lineHeight: 1.1 }}>
            The blog goes deeper.<br />
            <em style={{ color: "var(--accent)", fontStyle: "italic" }}>Every post has a guide.</em>
          </h2>
        </div>
        <a href="/blog" style={{
          display: "inline-flex", alignItems: "center", gap: "0.75rem",
          background: "var(--ochre)", color: "white",
          padding: "1rem 2rem", fontSize: "0.82rem", fontWeight: 500,
          letterSpacing: "0.1em", textTransform: "uppercase"
        }}>
          Read the blog →
        </a>
      </div>

      <Newsletter />
    </div>
  );
}
